import { render, staticRenderFns } from "./TestHome.vue?vue&type=template&id=ba572180&scoped=true&"
import script from "./TestHome.vue?vue&type=script&lang=js&"
export * from "./TestHome.vue?vue&type=script&lang=js&"
import style0 from "./TestHome.vue?vue&type=style&index=0&id=ba572180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba572180",
  null
  
)

export default component.exports